import React from 'react';
import { fmtDate } from '../../utils/format';

const ConversationList = ({ items = [], selectedId, onSelect, unreadKey = 'unreadByAssignee', onClose }) => {
  return (
    <div className="conv-list">
      {items.map((c) => (
        <div
          key={c._id}
          className={"conv-item " + (selectedId === c._id ? 'active' : '')}
          onClick={() => { onSelect && onSelect(c._id); onClose && onClose(); }}
        >
          <div className="avatar" style={{ width:36, height:36, background:'#e5e7eb', borderRadius:18 }} />
          <div className="meta">
            <div className="top">
              <div className="subject">{c.subject || '(no subject)'}</div>
              <div className="time">{fmtDate(c.lastMessageAt || c.updatedAt || c.createdAt)}</div>
            </div>
            <div className="preview">{c.preview || ''}</div>
          </div>
          {Number(c[unreadKey] || 0) > 0 && <span className="badge">{c[unreadKey]}</span>}
        </div>
      ))}
      {items.length === 0 && (
        <div style={{ padding:12, color:'#6b7280' }}>No conversations</div>
      )}
    </div>
  );
};

export default ConversationList;
